<template>
  <ams-table
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable
  },

  data() {
    return {
      ams_type: 'product-item-links',
      ams_api_path: 'api/admin/v1',
      ams_fields: [
       { 
          key: 'attributes.link-type',
          label: 'Type',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        },
        {
          key: 'attributes.url-link',
          label: 'Link',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc'
        },
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'brands',
          description_attr: 'name',
          append: ': '
        },
        {
          prepend: '',
          type: 'product-models',
          description_attr: 'name',
          append: ' '
        },
        {
          prepend: '#',
          type: 'product-listings',
          description_attr: 'edition',
          append: ' '
        },
        {
          prepend: 'copy(',
          type: 'product-items',
          description_attr: 'serial-number',
          append: ')'
        }
      ]
    }
  }
}
</script>